export const TranslationsKO = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: '인도네시아 바하사',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
    },
    // BASE
    phrases: {
        order_online: '온라인 주문',
        cart: '카트',
        open_24: '24시간',
        closed: '닫은',
        free: '무료',
        something_went_wrong: '뭔가 잘못됐어',
        try_again: '다시 시도',
    },
    constants: {
        calendar: {
            days: {
                monday: '월요일',
                tuesday: '화요일',
                wednesday: '수요일',
                thursday: '목요일',
                friday: '금요일',
                saturday: '토요일',
                sunday: '일요일',
            },
        },
        services: {
            pickup: '찾다',
            delivery: '배달',
            dine_in: '식사 가능',
            table_booking: '테이블 예약',
        },
        payment: {
            method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay(Checkout.com)',
                checkout_google_pay: 'Google Pay(Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate 페이웹',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: '밤보라 APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: '레드닷 결제',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate 페이웹',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: '밤보라 APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay(Checkout.com)',
                checkout_google_pay: 'Google Pay(Checkout.com)',
                stripe_digital_wallet: '구글/애플페이',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: '레드닷 결제',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: '성공',
                pending: '보류 중',
                error: '오류',
                refunded: '환불됨',
                refunding: '환불 중',
                partial_refunded: '부분 환불됨',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: '제거하다',
                drop_here: '여기에 파일을 놓거나 클릭하여 선택하세요.',
                accepts: '{{fileTypes}} 허가권',
                errors: {
                    max_files: '최대 {{number}}이(가) 허용됩니다.',
                    max_size: '최대 파일 크기: {{kilobytes}}KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: '해당 매장은 현재 문을 닫았으며 즉시 식사 주문을 할 수 없습니다. 대신 나중에 날짜와 시간으로 주문해 보세요.',
            },
            buttons: {
                order: {
                    book_order: '테이블 예약 / 온라인 주문',
                    order_online: '온라인 주문',
                    book_table: '테이블 예약',
                    order: '주문하다',
                    book: '책',
                    cart: '카트',
                    restart: '다시 시작',
                    closed: '매장 폐쇄',
                    not_accepting: '주문을 수락하지 않음',
                },
            },
        },
        modals: {
            auth: {
                login: '로그인',
                register: '등록하다',
                register_commence: '계속하다',
                register_complete: '계정 만들기',
                register_confirmation_sent: '귀하의 이메일 주소로 확인 코드가 전송되었습니다. 계속하려면 아래에 입력하세요.',
                register_confirmation_resent: '확인 코드가 다시 전송되었습니다. 스팸함을 확인하거나 프로세스를 다시 시작하세요.',
                register_restart: '다시 시작',
                register_resend_code: '코드 재전송',
                register_confirmation_code_subject: '이메일 확인 코드',
                register_confirmation_code_email: '귀하의 이메일 확인 코드는 {{confirmation_code}}입니다(24시간 후에 종료됨).',
                login_placeholder: '이메일',
                password_placeholder: '비밀번호',
                confirm_password_placeholder: '비밀번호 확인',
                confirmation_code_placeholder: '이메일 확인 코드',
                accept_terms: '이용약관에 동의하세요',
                accept_terms_view: '보다',
                login_facebook: '페이스북으로 로그인',
                login_google: 'Google로 로그인',
                benefits: '모든 주문을 저장하려면 로그인하거나 계정을 만드세요.',
                logged_in: '성공적으로 로그인되었습니다',
                logged_out: '로그아웃됨',
                password_reset: {
                    init_button: '비밀번호 재설정 메일 보내기',
                    init_success: '비밀번호 재설정 링크가 귀하의 이메일로 전송되었습니다',
                    complete_button: '비밀번호 재설정',
                    complete_success: '비밀번호가 재설정되었습니다. 새 비밀번호로 로그인하세요.',
                    forgot_password_text: '비밀번호를 잊으셨나요?',
                    forgot_password_link: '비밀번호 재설정',
                    remember_password_text: '비밀번호를 기억하시나요?',
                    remember_password_link: '돌아가기',
                    invalid_title: '비밀번호 재설정이 잘못되었습니다.',
                    invalid_description: '이 비밀번호 재설정 링크는 유효하지 않습니다. 대신 새 링크를 요청하세요.',
                    invalid_link: '로그인으로 이동',
                    title: '비밀번호 재설정',
                    description: '귀하의 계정에 대한 새 비밀번호를 입력하세요',
                },
                error_generic: '문제가 발생했습니다. 다시 시도하거나 문의해 주세요.',
                error_accept_terms: '이용약관에 동의해 주세요.',
                error_password_length: '비밀번호는 최소 6자 이상',
                error_social: '문제가 발생했습니다. 다시 시도하거나 문의해 주세요.',
                error_confirmation_code: '잘못된 확인 코드',
                error_invalid_code: '잘못된 확인 코드',
                error_exists: '사용자가 이미 존재합니다.',
                error_invalid_email_pass: '잘못된 이메일 주소 또는 비밀번호',
                error_password_no_match: '비밀번호가 서로 일치하지 않습니다.',
                error_user_not_found: '해당 이메일 주소를 가진 사용자가 없습니다.',
                error_invalid_email: '잘못된 이메일 주소',
                error_invalid_reset_token: '재설정 링크가 잘못되었습니다. 다른 재설정 링크를 요청하세요.',
            },
            booking: {
                form: {
                    name: '성명',
                    email: '이메일 주소',
                    phone: '전화 번호',
                    number_of_people: '인원수',
                    number_of_people_max: '정글수({{max_people}} 최대)',
                    number_of_people_min: '임시수({{min_people}}분)',
                    number_of_people_max_min: '중간수({{min_people}}~{{max_people}} 사이)',
                    notes: '참고 사항/특별 요청 사항',
                    submit: '예약 요청 제출',
                    email_optional: '(선택)',
                    date: '날짜',
                    duration: '소요 시간',
                    seating: '예약 가능 시간',
                    number_of_guests: '인원수',
                    notes_placeholder: '알레르기, 방문 목적, 좌석 선호',
                    reserving: '예약하는 중...',
                    reserve_table: '테이블 예약',
                    please_choose_a_date_and_time: '날짜와 시간을 선택해 주세요.',
                    invalid_people: '인원수는 {{min}}명에서 {{max}}명 사이여야 합니다.',
                    party_size_max_fallback: '허용된 최대 인원',
                    loading_available_times: '예약 가능 시간을 불러오는 중…',
                    select_a_date_to_see_available_times: '날짜를 선택하면 예약 가능 시간이 표시됩니다.',
                    no_times_available_for_this_date: '이 날짜에는 예약 가능한 시간이 없습니다. 다른 날을 선택해 주세요.',
                    shift: '시간대',
                    service_times: '영업 시간',
                    new_shift: '새 시간대',
                    time: '개',
                    times: '개',
                    unavailable: '예약 불가',
                    available: '예약 가능',
                    required_name: '이름을 입력해 주세요.',
                    required_phone: '전화번호를 입력해 주세요.',
                    required_email: '이메일을 입력해 주세요.',
                    invalid_email: '올바른 이메일을 입력해 주세요.',
                    required_terms: '예약하기 전에 약관에 동의해 주세요.',
                    reservation_is_unavailable: '예약을 받을 수 없습니다.',
                    please_contact_the_restaurant_directly: '매장에 직접 문의해 주세요.',
                    almost_done: '거의 완료',
                    your_details: '고객 정보',
                    tell_us_who_s_coming: '예약을 확정할 수 있도록 누가 오시는지 알려 주세요.',
                    book_your_table: '테이블 예약하기',
                    choose_a_time_that_works_for_you: '편한 시간을 선택해 주세요.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: '예약 요청을 보내시면 나머지는 매장에서 처리합니다.',
                    select_date: '날짜 선택',
                    standard: '기본',
                    minutes: '분',
                    next: '다음 →',
                    back: '← 뒤로',
                    accept_terms: '이용약관에 동의합니다.',
                    info_1: '예약이 승인되거나 거부되면 이메일 알림을 받게 됩니다.',
                },
                errors: {
                    not_found: '예약이 존재하지 않습니다. 삭제되었을 수 있습니다.',
                    generic: '문제가 발생했습니다. 페이지를 새로 고치거나 문의해 주세요.',
                    something_went_wrong: '문제가 발생했습니다.',
                    accept_terms: '이용약관에 동의해 주세요.',
                    required_phone: '전화번호를 입력해주세요',
                    required_email: '이메일을 입력해주세요',
                    required_zip: '청구지 우편번호를 입력하세요.',
                    required_name: '이름을 입력해주세요',
                    invalid_email: '유효한 이메일 주소를 입력해주세요',
                    invalid_phone: '유효한 전화번호를 입력하세요.',
                    invalid_people: '인원수가 잘못되었습니다.',
                    missing_custom_fields: '필수 입력란을 모두 작성해 주세요.',
                    booking_capacity_threshold: '이 시간은 예약이 마감되었습니다. 다른 시간을 선택해 주세요.',
                    slot_unavailable: '이 인원수는 예약이 마감되었습니다. 다른 시간을 선택해 주세요.',
                    booking_date_paused: '이 날짜의 예약이 일시 중지되었습니다. 다른 날을 선택해 주세요.',
                    invalid_table_assignment: '해당 테이블은 인원을 수용할 수 없습니다. 다른 시간을 선택해 주세요.',
                    exceeded_order_limit: '예약 요청이 너무 많습니다. 나중에 다시 시도해 주세요.',
                    validation_failed_recaptcha_v3: '비정상적인 트래픽이 감지되었습니다. VPN을 사용 중이신가요? 위의 확인을 완료하고 다시 시도해 주세요.',
                    validation_failed_recaptcha_v2: '예약을 시작할 수 없습니다. 다시 시도하거나 다른 방법을 이용해 주세요. VPN을 사용 중이라면 먼저 꺼 보세요.',
                    booking_already_exists: '이 예약은 이미 제출되었습니다. 이메일을 확인하거나 예약 링크를 열어 주세요.',
                    invalid_party_size: '올바른 인원수를 선택해 주세요.',
                    invalid_request: '잘못된 요청입니다. 페이지를 새로고침하고 다시 시도해 주세요.',
                    table_booking_unavailable: '테이블 예약을 이용할 수 없습니다.',
                },
            },
            cart: {
                title: '카트',
                proceed_to_checkout: '결제로 진행',
                edit_dish: '편집하다',
                remove_dish: '제거하다',
                no_items_1: '장바구니에 상품이 없습니다',
                no_items_2: '계속하려면 먼저 일부를 추가하세요.',
                free_delivery_notice: '{{value, currency}} 이상 주문 시 무료 배송',
                errors: {
                    min_order_promo: '이 프로모션을 적용하기 전에 필요한 최소 카트리지 금액은 {{value, currency}}입니다.',
                    min_order_delivery: '배송을 위한 소수의 카운터 금액 {{value, currency}}',
                },
                promo: {
                    heading: '프로모션 코드',
                    placeholder: '프로모션 코드를 입력하세요',
                    add: '코드 추가',
                    title: '{{name}}이 프로모션에 추가되었습니다.',
                    fixed_discount: '{{value, currency}} 잠시 짐',
                    percent_discount: '{{value}}% 할인',
                    added_to_cart: '장바구니에 프로모션이 추가되었습니다.',
                    errors: {
                        not_found: '프로모션을 찾을 수 없습니다.',
                        disabled: '프로모션이 비활성화되었습니다.',
                        not_available: '현재 프로모션을 이용할 수 없습니다.',
                        not_eligible: '프로모션 코드를 적용할 수 없습니다.',
                        not_available_time: '이번에는 프로모션이 적용되지 않습니다',
                        logged_in_only: '이 프로모션을 사용하려면 로그인해야 합니다',
                        already_used: '이미 이 프로모션을 사용하셨습니다.',
                        invalid: '이 프로모션은 더 이상 유효하지 않습니다.',
                        invalid_service: '이 프로모션은 선택한 서비스에 유효하지 않습니다.',
                        later_only: '사전 주문에만 유효',
                        now_only: '선주문이 아닌 즉시 주문에만 유효합니다.',
                        generic: '이런... 문제가 발생하여 기록되었습니다.',
                        dishes_required_multi: '이 프로모션은 특정 품목을 장바구니에 추가한 경우에만 적용됩니다.',
                        dishes_required_single: "이 프로모션은 '{{dish}}'에만 적용됩니다",
                    },
                },
                tip: {
                    title: '주문 팁',
                    placeholder: '주문 팁 추가',
                },
            },
            free_items_promo: {
                title: '무료 품목',
                usage_confirmation: {
                    question: '무료 아이템을 받으실 수 있습니다. 보고 추가하시겠습니까?',
                    cancellation: "아니요, 무료 항목은 원하지 않습니다",
                    acceptance: '예',
                },
                free_items_selection: {
                    multiple: {
                        description: '{{number}} 무료 항목을 선택하세요.',
                    },
                    single: {
                        description: '무료 항목을 선택하세요',
                    },
                    confirm_button: '확인하다',
                },
            },
            checkout: {
                title: '점검',
                subtitle: '주문 세부정보를 확인하세요.',
                details: {
                    service: '서비스',
                    due: '로 인한',
                    due_now_asap: '지금 / 최대한 빨리',
                    address: '배송 주소',
                    total: '총',
                    table: '테이블',
                    store_location: '매장 주소',
                },
                customer: {
                    title: '고객',
                    subtitle: '주문 및 세부정보를 저장하려면 로그인하세요.',
                    button: '로그인',
                    name: '성명',
                    email: '이메일',
                    phone: '핸드폰',
                    phone_important: '전화 (중요)',
                    notes: '주문 메모',
                    delivery_notes: '배송 지침/주문 메모',
                    optional: '선택 과목',
                },
                payment: {
                    title: '결제수단',
                    qr_modal_help: '{{app}} 모바일 애플리케이션을 사용하여 QR을 스캔하고 이 주문에 대한 결제를 완료하세요. 모바일 애플리케이션에서 결제가 완료되면 이 QR 모달을 닫을 수 있습니다. 결제 프로세스가 완료되지 않은 경우 이 QR 모달을 닫지 마십시오.',
                    switch_to_app_help: '아래 버튼을 누르면 {{app}} 모바일 애플리케이션이 자동으로 열리고 이 주문에 대한 결제가 완료됩니다. 모바일 애플리케이션에서 결제가 완료되면 이 모달을 닫을 수 있습니다. 결제 프로세스를 완료하지 않은 경우 이 모달을 닫지 마십시오.',
                    open_app: '{{app}} 직원에게',
                    continue: '계속하다',
                    continue_to_payment: '{{method}}로 계속됩니다',
                    back_to_cart: '장바구니로 돌아가기',
                },
                accept_terms: '이용약관에 동의하세요',
                accept_terms_view: '보다',
                processing_order: '처리 순서',
                warning: {
                    different_payment_currency: '매장 가격은 {{store_currency}}에 있지만 결제 수단은 {{payment_currency}}에 있습니다.',
                    closing_soon: '곧 마감됩니다. 주문은 {{value}}분 이내에 접수하셔야 합니다.',
                    closed: '죄송합니다. 서비스가 종료되어 주문을 받지 않습니다.',
                    paused: '죄송합니다. 이 서비스는 일시 중지되었으며 지금은 주문을 받지 않습니다.',
                    expired: '귀하가 선택한 시간에는 더 이상 주문을 처리할 수 없습니다. 나중에 날짜나 시간을 선택하세요.',
                },
                errors: {
                    walletly_promo: '월렛 프로모션에 오류가 있습니다. 다른 프로모션을 시도해 보세요!',
                    stripe_generic: '신용카드 오류입니다. 다시 시도하거나 다른 방법을 사용하세요.',
                    validation_failed: '지금은 이 결제를 수락할 수 없습니다. 나중에 다시 시도하거나 다른 결제 수단을 선택하세요.',
                    validation_failed_recaptcha_v3: '특별한 느낌이 들었습니다. VPN을 사용하고 있나요? 위의 과제를 시도하고 다시 시도하세요.',
                    validation_failed_recaptcha_v2: '결제를 하실 수 없습니다. 다시 시도하거나 다른 방법을 시작해보세요. VPN을 사용하고 있다면 먼저 VPN을 쉬세요.',
                    stripe_loading_fail: '결제 양식을 로드하는 중에 오류가 발생했습니다. 다시 시도해 주세요.',
                    something_went_wrong: '문제가 발생했습니다.',
                    paypal_generic: 'PayPal에 문제가 발생했습니다. 다시 시도하거나 다른 결제 수단을 선택하세요.',
                    payment_fail: '결제에 실패했습니다. 다시 시도하거나 다른 결제 수단을 선택하세요.',
                    payment_cancelled: '결제가 취소되었습니다. 다시 시도하거나 다른 결제 수단을 선택하세요.',
                    payment_error: '온라인 결제를 처리하는 중에 오류가 발생했습니다. 다시 시도하거나 다른 결제 방법을 선택하세요.',
                    payment_declined: '결제 수단이 거부되었습니다',
                    card_declined: "귀하의 카드가 거부되었고 결제를 처리할 수 없습니다",
                    promo_max_uses_exceeded: "이 프로모션 코드는 사용 한도에 도달하여 더 이상 사용할 수 없습니다.",
                    store_closed: '매장이 문을 닫아서 더 이상 주문을 받지 않습니다',
                    accept_terms: '이용약관에 동의해 주세요.',
                    required_payment: '결제수단을 선택해주세요',
                    required_phone: '전화번호를 입력해주세요',
                    required_email: '이메일을 입력해주세요',
                    required_zip: '청구지 우편번호를 입력하세요.',
                    required_name: '이름을 입력해주세요',
                    invalid_email: '유효한 이메일 주소를 입력해주세요',
                    invalid_phone: '유효한 전화번호를 입력하세요.',
                    invalid_cc_number: '귀하의 신용카드 번호가 유효하지 않습니다.',
                    invalid_order_amount: '이 결제 수단에 필요한 최소 금액',
                    retry_cc_number: '문제가 발생했습니다. 신용카드 번호를 다시 입력하고 다시 시도하세요.',
                    closed: '매장이 문을 닫아서 주문을 받지 않습니다',
                    promo_login_required: '이 프로모션을 사용하려면 로그인해야 합니다',
                    promo_used: '이미 이 프로모션을 사용하셨습니다.',
                    promo_by_payment_method_not_applicable: '선택한 결제 수단에는 프로모션이 적용되지 않습니다.',
                    missing_custom_checkout_fields: '필수 입력란을 모두 작성해 주세요.',
                    delivery_unavailable: '현재 배송 서비스가 제공되지 않을 수 있습니다. 대신 픽업 주문을 고려해 보세요.',
                    required_delivery_provider: '배송 서비스를 선택해주세요.',
                    required_delivery_quotation: '예상 배송 기간이 만료되었습니다.',
                    exceeded_order_limit: '현재 주문이 많이 들어오고 있습니다. 나중에 시간을 선택해 주세요.',
                    exceeded_order_limit_later: '귀하가 선택한 시간에는 더 이상 주문을 처리할 수 없습니다. 나중에 날짜나 시간을 선택하세요.',
                },
                button: {
                    continue: '결제 계속',
                    place_order: '주문하기',
                    update_order: '업데이트 순서',
                },
                delivery_estimation: {
                    title: '배송 견적',
                    details: {
                        provider: '배송업체',
                        estimated_fee: '예상 수수료',
                        estimated_total_fee: '배송비 총액',
                        estimated_discount_fee: '배송비 할인',
                        previous_estimated_fee: '이전 예상 수수료',
                        tips: '팁',
                        estimated_delivery_time: '예상 배송 시간',
                        uber_new_estimation: '새로운 견적 요청',
                        uber_new_estimation_success: '새로운 Uber 출시 예정인 비가 적용되었습니다.',
                        uber_estimation_expired: '예상 배송 기간이 만료되었습니다.',
                        uber_price: 'Uber 가격을 유지하고 있습니다',
                        uber_need_time: '시간이 더 필요해요',
                        lalamove_price: '랄라무브 배송비를 보유하고 있습니다',
                        lalamove_new_estimation_success: '새로운 Lalalmove 출시가 예상됩니다.',
                        lalamove_estimation_expired: '예상 배송 기간이 만료되었습니다.',
                        lalamove_need_time: '시간이 더 필요해요',
                        lalamove_new_estimation: '새로운 견적 요청',
                    },
                    quotation_error: '예상 배송비를 계산하는 중에 문제가 발생했습니다.',
                },
            },
            customer: {
                age_v: {
                    title: '연령 확인',
                    required_for_items: '특정 품목을 주문하는 데 필요합니다.',
                    min_age: '최소 연령: {{age}}세',
                    est_time: '예상 확인 시간: {{time}}시간',
                    upload_description: '확인을 위해 아래에 신분증을 업로드하세요. 확인되면 이메일로 통보해 드립니다. 각 최대 크기가 2MB인 이미지를 최대 2개 업로드하세요.',
                    pending_description_1: '서류를 제출해 주셔서 감사합니다. 승인되면 이메일로 통보됩니다.',
                    pending_description_2: '확인 상태를 업데이트하려면 페이지를 새로 고치세요. 예상 확인 시간은 {{time}}시간입니다.',
                    approved_description: '귀하의 계정이 확인되었으며 제한된 메뉴에서 주문할 수 있습니다',
                    rejected_description: '귀하의 신분증이 거부되었습니다. 다시 시도하시려면 신분증을 다시 업로드해주세요.',
                    upload: '업로드',
                    reupload: '문서 다시 업로드',
                    go_back: '돌아가기',
                    view_document: '문서 보기 {{number}}',
                    status: {
                        unverified: '확인되지 않음',
                        pending: '승인을 기다리는 중',
                        approved: '성공적으로 확인되었습니다',
                        rejected: '거부됨',
                    },
                },
                headings: {
                    sessions: '세션',
                    orders: '주문하다',
                    spend: '경비',
                    order_history: '주문 내역',
                    loyalty: '충의',
                    loyalty_points: '로열티 포인트',
                    added: '프로모션이 추가되었습니다.',
                },
                loyalty_errors: {
                    invalid_cart_items: '교환하기 전에 항목을 선택하십시오!',
                    not_found: '프로모션을 찾을 수 없습니다!',
                    already_exists: '프로모션이 이미 존재합니다!',
                    try_again: '이 거래를 적용할 수 없습니다. 다시 시도해 주세요!',
                },
            },
            custom_payment: {
                title: '{{name}} 지불 양식',
                description: '온라인 결제 양식에 도달하셨습니다. 결제를 위해 아래 항목을 작성해주세요. 금액을 입력하지 않으면 정보는 저장되지만 요금은 청구되지 않습니다.',
                disabled: '이 온라인 결제 페이지가 올바르게 구성되지 않았습니다. 문제를 해결하려면 사이트 소유자에게 문의하세요.',
                success: '결제가 성공적으로 처리되었으며 세부정보가 저장되었습니다. 감사합니다',
                back: '홈으로 돌아가기',
                fields: {
                    name: '성명',
                    email: '이메일 주소',
                    reference: '결제 참조',
                    amount: '금액($)',
                    name_on_card: '카드에 이름을 적다',
                    submit: '결제 제출',
                },
                warning: {
                    currency: '참고: 결제금액은 {{default}}이가 아닌 {{actual}}로 표시됩니다.',
                },
                errors: {
                    generic: '문제가 발생했습니다. 다시 시도하거나 문의해 주세요.',
                    stripe_generic: '신용카드 오류입니다. 페이지를 새로고침한 후 다시 시도하세요.',
                    payment_fail: '결제에 실패했습니다. 다시 시도하거나 다른 결제 수단을 선택하세요.',
                    payment_cancelled: '결제가 취소되었습니다. 다시 시도하거나 다른 결제 수단을 선택하세요.',
                    payment_error: '온라인 결제를 처리하는 중에 오류가 발생했습니다. 다시 시도하거나 다른 결제 방법을 선택하세요.',
                    payment_declined: '결제 수단이 거부되었습니다',
                    card_declined: "귀하의 카드가 거부되었고 결제를 처리할 수 없습니다",
                    promo_max_uses_exceeded: "이 프로모션 코드는 사용 한도에 도달하여 더 이상 사용할 수 없습니다.",
                },
            },
            dish: {
                add: '장바구니에 추가',
                edit: '업데이트 항목',
                notes: '특별 지시사항...',
                ingredients: {
                    title: '재료',
                    uncheck_remove: '제거하려면 선택을 취소하세요.',
                },
                ingredients_title: '재료',
                combo: {
                    choose_dish: '항목을 선택하세요',
                },
                option_sets: {
                    conditions: {
                        select_one: '하나를 선택하세요(필수)',
                        select_one_optional: '하나를 선택하세요(선택사항)',
                        select_between: '{{min}} - {{max}} 선언하세요. (필수)',
                        select_at_least: '{{qty}} 이상을 선택하세요(필수).',
                        select_up_to: '최대 {{qty}}까지 선택하세요(선택사항).',
                        select_multiple_optional: '여러 개 선택(선택사항)',
                        select_multiple: '여러개 선택 (필수)',
                        free_amount: '첫 번째 {{qty}} 무료 / {{selected}} 선택됨',
                    },
                    points: {
                        none_consumed: '최대 {{maxFree}} 옵션을 별도로 선택할 수 있습니다.',
                        less_than_total_points: '무료로 더 많은 옵션을 선택할 수 있습니다.',
                        greather_than_total_points: '추가 비용을 지불하면 더 많은 옵션을 선택할 수 있습니다.',
                    },
                },
                error: '빨간색으로 표시된 옵션을 수정하세요.',
                added_to_cart: '장바구니에 추가된 품목',
            },
            map: {
                zone_fee: '배송비',
                view_in_google: 'Google 지도에서 보기',
            },
            portal_go_back: {
                title: '레스토랑 검색으로 돌아가시겠습니까?',
                description: '장바구니에 있는 모든 항목이 손실됩니다.',
                cancel: '취소',
                proceed: '돌아가기',
            },
            order: {
                config: {
                    services: {
                        title: '서비스를 선택하세요',
                        table_booking: '책 테이블',
                    },
                    address_custom: {
                        input_placeholder: '주소를 입력하세요',
                    },
                    address: {
                        input_placeholder: '배송 주소 찾기',
                        extras_placeholder: '호실번호, 건물명, 배송안내 등...',
                        search_placeholder: '주소 검색',
                        search_input_placeholder: '검색하려면 입력하세요.',
                        no_address_found: '주소를 찾을 수 없습니다. 5자 이상 입력해 보세요.',
                        not_found: '배송 주소를 찾을 수 없거나 유효하지 않습니다. 다시 시도해 주세요.',
                        not_delivering: '현재 이 주소로는 배송되지 않습니다',
                        not_in_range: '귀하의 주소가 우리 매장 위치 범위를 벗어났습니다.',
                        not_in_zone: '귀하의 주소가 활성 배송 지역 내에 있지 않습니다.',
                        no_number: '주소에는 거리 번호가 있어야 합니다.',
                        location_permission: '이 웹사이트가 현재 위치에 액세스하도록 허용하시겠습니까?',
                        location_permission_warning: "현재 위치에 접근할 수 없습니다. 기기와 웹 브라우저에서 위치 서비스를 활성화하세요. 여기에 몇 가지 참조가 있습니다:",
                        pick_location: '귀하의 위치를 ​​선택하세요',
                        pick_location_help_text: '지도에서 위치를 선택하려면 마커를 드래그하세요.',
                        use_current_location: '현재 위치 사용',
                        locate_on_map: '지도에서 찾기',
                    },
                    datetime: {
                        title: '언제 주문하시겠습니까?',
                        due_now: '지금',
                        due_later: '나중에',
                        service_not_available: '진심입니다. 현재 {{service}} 주문을 받지 않습니다.',
                        currently_closed: '{{service}}은(는) 현재 문을 닫았지만 나중에 주문할 수 있습니다.',
                        due_unavailable: '없는',
                        due_closed: '닫은',
                        select_date: '날짜 선택',
                        select_time: '시간 선택',
                        select_order_date: '주문 날짜를 선택하세요',
                        select_order_time: '주문 시간을 선택하세요',
                        select_order_date_time: '주문 날짜/시간을 선택하세요',
                        select_booking_date: '예약 날짜를 선택하세요',
                        select_booking_time: '예약 시간을 선택하세요',
                        no_times_available: '선택할 수 있는 시간이 없습니다.',
                        date_today: '(오늘)',
                        date_closed: '(닫은)',
                        date_bookings_paused: '(예약 일시 중지)',
                        time_slot_closed: '닫은',
                    },
                    number_of_people: {
                        placeholder: '인원수',
                    },
                    table: {
                        select: '테이블 선택',
                        select_popup_title: '테이블을 선택하세요',
                        password: '테이블 비밀번호',
                        password_warning: '계속 진행하려면 테이블 비밀번호를 입력하세요.',
                    },
                    warning: {
                        closed: '죄송합니다. 현재 영업이 종료되어 주문을 받지 않습니다.',
                        not_available: '죄송합니다. 현재 주문을 받고 있지 않습니다.',
                    },
                    eta: {
                        delivery: `예상 배송 시간은 약 {{minutesToCustomer}}분입니다.`,
                        pickup: `주문은 약 {{minutesToCustomer}}분 후에 준비가 완료됩니다.`,
                    },
                    start_button: '시작 주문',
                },
                history: {
                    invalid: '주문한 상품 중 일부가 변경되었거나 더 이상 구매할 수 없으므로 재주문할 수 없습니다.',
                },
                reorder: {
                    title: '빠른 재주문',
                    description: '이전 주문 항목을 쉽게 주문하세요.',
                },
            },
            receipt: {
                errors: {
                    not_found: '주문을 찾을 수 없습니다. 페이지를 새로고침한 후 다시 시도하세요.',
                    booking_not_found: '예약이 존재하지 않습니다. 삭제되었을 수 있습니다',
                    generic: '문제가 발생했습니다. 페이지를 새로 고치거나 문의해 주세요.',
                },
                connection: {
                    connected: '실시간 업데이트',
                    connecting: '실시간 업데이트 연결',
                    disconnected: '실시간 업데이트 연결이 끊어졌습니다.',
                },
            },
            warnings: {
                logout: {
                    pretitle: '경고',
                    title: '로그아웃',
                    body: '로그아웃하면 장바구니에 추가된 모든 항목이 제거됩니다.',
                    cancel: '취소',
                    proceed: '진행하다',
                },
                order_restart: {
                    warning: '경고',
                    title: '변경 주문 세부정보',
                    body: '주문 세부 정보를 변경하면 특정 품목을 사용할 수 없게 되므로 장바구니에 있는 품목이 제거됩니다.',
                    cancel: '취소',
                    proceed: '진행하다',
                },
                order_expired: {
                    subtitle: '중요한',
                    title: '주문이 즉시 마감으로 변경되었습니다.',
                    description: '귀하가 주문한 시간이 이제 멀지 않았습니다. 따라서 귀하의 주문은 즉시/최대한 빨리 마감되도록 변경되었습니다.',
                    button: '좋아요',
                },
                order_expiring: {
                    subtitle: '중요한',
                    title: '주문 마감일이 곧 만료됩니다',
                    description: '주문은 {{time, timeFromTimestamp}} 이전에 해야 합니다. 그렇지 않으면 더 이상 유효하지 않습니다.',
                    button: '좋아요',
                },
                location_permission: {
                    cancel: '취소',
                    proceed: '진행하다',
                },
            },
            card_payment_authentication: {
                title: '결제 인증',
                note: '은행 인증 절차가 완료될 때까지 이 창을 열어두시기 바랍니다.',
            },
            maps: {
                cancel: '취소',
                use_location: '위치 사용',
            },
            app_refresh: {
                refresh: '새로 고치다',
                title: '리프레시 스토어',
                description: '저희 매장이 업데이트 되었습니다. 최신 버전에 액세스하려면 브라우저를 새로 고치십시오. 새로 고친 후 결제 프로세스를 진행하려면 장바구니를 다시 열어야 할 수도 있습니다.',
            },
        },
        sections: {
            nav_top: {
                guest: '손님',
                login: '로그인',
                login_signup: '로그인 / 회원가입',
                logout: '로그아웃',
            },
            menus: {
                info: {
                    no_menus: '현재 이용 가능한 메뉴가 없습니다.',
                    restrictions: '메뉴 제한사항',
                    not_available: '사용할 수 없는 메뉴',
                    unavailable: {
                        times: "메뉴를 이용할 수 없습니다. 주문 요구 사항이 아래와 일치하지 않습니다",
                        services: "메뉴를 이용할 수 없습니다. 주문 요구 사항이 아래와 일치하지 않습니다",
                        hours: '메뉴를 이용할 수 없습니다. 주문 시간은 해당 메뉴 이용 가능 시간이 아닙니다.',
                        pre_order: "메뉴를 이용할 수 없습니다. 주문 요구 사항이 아래와 일치하지 않습니다",
                        age: '메뉴를 이용할 수 없습니다. 이 메뉴를 주문하려면 연령 인증 계정으로 로그인해야 합니다.',
                    },
                    services: {
                        title: '주문 요구 사항',
                        pickup: '픽업',
                        delivery: '배달',
                        dine_in: '식사 공간',
                    },
                    times: {
                        now: '선주문 없음',
                        later: '사전 주문만 가능',
                    },
                    hours: {
                        title: '이용 가능 시간',
                    },
                    preorder: {
                        title: '선주문 요구 사항',
                        days_in_advance: '{{days}}일 전에 미리 주문해야 합니다.',
                        cutoff_time: '마지막 날 종료 시간: {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: '연령 제한',
                        approved: '귀하의 계정이 확인되었으며 이 메뉴에서 주문할 수 있습니다',
                        rejected: '주문하려면 연령 확인이 필요합니다. 계정을 만들고 신분증을 업로드하세요',
                    },
                },
                search: {
                    title: '메뉴 항목 탐색',
                    no_result: '아무것도 돌아오지 않았습니다. 다른 검색어를 사용해 보시겠습니까?',
                    placeholder: '무엇을 찾고 계신가요?',
                },
            },
            category: {
                restrictions: '카테고리 제한',
                not_available: '카테고리 없음',
                unavailable: {
                    services: '카테고리를 이용할 수 없습니다. 주문 요구 사항이 아래 조건과 일치하지 않습니다.',
                    hours: '카테고리를 이용할 수 없습니다. 주문 시간이 이 카테고리의 이용 가능 시간에 포함되지 않습니다.',
                },
            },
            info: {
                location: {
                    title: '위치',
                    view_map: '지도 보기',
                    phone: '핸드폰',
                },
                hours: {
                    title: '영업시간',
                    title_special: '특별 영업 시간',
                },
                services: {
                    title: '서비스',
                    notes: '메모',
                    delivery: {
                        ranges: '배송 범위',
                        zones: '배달 지역',
                        view_zones: '지도에서 구역 보기',
                        fee: '배송비',
                        fee_short: '요금',
                        fee_varies: '장바구니에 표시됨',
                        min_order: '최소 주문',
                        min_order_short: '최소',
                        no_min_order: '최소 주문 없음',
                        free_amount: '무료배송금액',
                    },
                },
            },
            contact: {
                title: '문의하기',
                name: '이름',
                email: '이메일',
                phone: '전화 번호',
                message: '메시지를 입력하세요...',
                send: '메시지 보내기',
                success: '귀하의 메시지가 성공적으로 전송되었습니다',
                error: '문제가 발생했습니다. 다시 시도하거나 나중에 시도하세요.',
            },
            footer: {
                powered_by: '에 의해 구동',
                terms_and_conditions: '이용약관',
                privacy: '개인 정보 보호 정책',
                cookie: '쿠키 정책',
            },
        },
        pages: {
            payment_completed: {
                title: '결제가 처리되었습니다. 주문해주셔서 감사합니다!',
                subtitle: '주문 정보가 귀하의 이메일 주소로 전송되었습니다.',
                back_to_menu: '메뉴로 돌아가기',
                close_tab: '이 탭 닫기',
            },
            payment_failed: {
                title: '안타깝게도 결제를 처리하는 동안 오류가 발생했습니다.',
                subtitle: '',
                back_to_menu: '메뉴로 돌아가기',
                close_tab: '이 탭 닫기',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: '예약 영수증',
            details: {
                datetime: '예약대상',
                number_of_people: '인원수',
                placed: '배치됨',
                updated: '마지막 업데이트',
                notes: '메모',
                name: '이름',
                email: '이메일',
                phone: '핸드폰',
                store_address: '매장 주소',
            },
            status_update: {
                title: '예약 {{number}}업데이트됨',
                body: '예약 상태가 {{status}}(으)로 업데이트되었습니다.',
            },
            email_common: {
                name: '이름: {{name}}',
                phone: '전화번호: {{number}}',
                number_of_people: '본인수: {{number}}',
                date: '날짜: {{date}}',
                time: '시간: {{time}}',
                location: '위치: {{name}}',
                notes: '참고: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: '새 테이블 예약 {{number}} 작성자: {{name}}',
                powered_by: '{{name}} 제공',
                overview: '새 테이블 예약 요청',
                title: '{{name}}에 대한 신규 예약',
                subtitle: '예약 번호 {{number}}',
                description_confirmed: '예약이 자동으로 확정되었습니다. 관리자 대시보드를 통해 취소할 수 있으며 고객에게 이메일로 알림이 전송됩니다.',
                description_unconfirmed: '관리자 대시보드를 통해 예약을 확인하거나 취소하세요.',
                url_pre_text: '보기 및 업데이트:',
            },
            email_new_booking_customer: {
                subject: '테이블 예약 요청',
                powered_by: '{{name}} 제공',
                overview: '새 테이블 예약 요청',
                title: '예약해주셔서 감사합니다',
                subtitle: '예약 번호 {{number}}',
                description: '<b>예약이 확인되거나 거부되면 또 다른 이메일을 받게 됩니다.</b><br>예약을 변경하려면 당사에 문의하시기 바랍니다. 예약 세부정보는 다음과 같습니다.',
                url_pre_text: '실시간 예약 영수증은 다음에서 확인하실 수 있습니다.',
            },
            email_update_booking_customer: {
                subject_confirmed: '테이블 예약이 확인되었습니다',
                subject_unconfirmed: '테이블 예약이 취소되었습니다',
                powered_by: '{{name}} 제공',
                overview: '테이블 예약 요청',
                title_confirmed: '예약이 확인되었습니다',
                title_unconfirmed: '예약이 취소되었습니다',
                subtitle: '예약 번호 {{number}}',
                description_confirmed: '우리는 당신을 만나기를 기대합니다. 예약 변경을 요청하려면 저희에게 연락해주세요.',
                description_unconfirmed: '귀하의 예약 요청을 수락할 수 없음을 알려드리게 되어 유감입니다. 불편을 끼쳐드려 죄송합니다. 궁금한 점이 있으면 문의해 주세요.',
                url_pre_text: '실시간 예약 영수증은 다음에서 확인하실 수 있습니다.',
            },
            email_status_update_customer: {
                subject: '예약 #{{number}} – {{subjectLabel}}',
                body: '{{store}} 예약 #{{number}}의 상태가 {{status}}(으)로 변경되었습니다.',
            },
            errors: {},
            status_warning: '예약 페이지의 관리 대시보드에서 이 예약 상태를 업데이트하세요.',
        },
    },
    email_delayed_order: {
        subject: '주문 #{{number}} – {{subjectLabel}}',
        header: '준비 완료 시간 변경',
        title: '준비 완료 시간 변경',
        order_number: '주문 번호: {{number}}',
        description: '주문은 {{time}}에 준비됩니다.',
        order_time_updated_to: '주문 시간이 변경되었습니다.',
        powered_by: '{{name}} 제공',
        button_text: '주문 추적',
        subject_label: '준비 완료 시간 변경',
        subject_label_delivery: '배달 시간 변경',
        body_ready: '주문은 {{time}}에 준비됩니다.',
        body_delivery: '주문은 {{time}}에 배달됩니다.',
    },
    order: {
        receipt: {
            est_ready_time: '예상 준비 시간',
            est_driver_pickup_time: '예상 드라이버 픽업 시간',
            est_delivery_time: '예상 배달 시간',
            tab_details: '세부',
            tab_dishes: '품목',
            future_order: '미래의 질서',
            reprint: '재판',
            details: {
                order_no: '주문번호',
                status: '상태',
                placed: '배치됨',
                due: '로 인한',
                due_asap: '지금 / 최대한 빨리',
                last_updated: '마지막 업데이트',
                total: '총',
                type: '유형',
                origin: '기원',
                table: '테이블',
                number_of_people: '인원수',
                payment_method: '결제수단',
                payment_status: '결제 상태',
                payment_currency: '결제 통화',
                notes: '메모',
                name: '이름',
                email: '이메일',
                phone: '핸드폰',
                distance: '거리',
                driving_time: '운전 시간',
                delivery_zone: '존',
                delivery_address: '배송 주소',
                delivery_provider: '배송업체',
                delivery_tracking: '배송 추적',
                delivery_return_tracking: '반품 추적',
                delivery_tracking_link: '주문 추적',
                tookan_status: '투칸 상태',
                tookan_status_failed_book: '예약배송 실패',
                tookan_status_failed_update: '예약을 업데이트하지 못했습니다.',
                tookan_status_success: '배달 예약됨',
                store_address: '매장 주소',
                destination: '목적지',
                estimated_arrival_time: '예상 도착 시간',
                delivery_status: '상태',
                delivery_track_your_order: '주문 추적',
                delivery_text: '배달',
                arrival_date: '도착 날짜',
            },
            dishes: {
                headings: {
                    quantity: '수량',
                    item: '목',
                    price: '가격',
                },
                notes: '메모',
                remove_ingredients: '성분 제거',
            },
            status_update: {
                title: '주문 {{number}}업데이트됨',
                body: '주문 상태가 {{status}}(으)로 업데이트되었습니다.',
            },
            wait_time_update: {
                title: '주문 {{number}}업데이트됨',
                body: '주문 마감 시간이 업데이트되었습니다.',
            },
            delivery_update: {
                title: '주문 {{number}}업데이트됨',
                body: '귀하의 주문은 배송 예약이 완료되었습니다. 실시간 추적 링크 보기',
            },
            payment_status_update: {
                title: '주문 {{number}}업데이트됨',
                body: '귀하의 주문 결제 상태가 업데이트되었습니다.',
            },
            email_new_order_restaurant: {
                subject: '주문({{number}}) - {{name}} 신규',
                powered_by: '{{name}} 제공',
                overview: '신규 주문 알림',
                title: '{{name}}에 새로운 주문이 접수되었습니다.',
                subtitle: '주문 번호 {{number}}',
                description: '관리 대시보드를 통해 세부정보 및 업데이트를 확인하세요.',
                button_text: '주문 추적',
                track_delivery_button_text: '배송 추적',
            },
            email_new_order_customer: {
                subject: '주문해주세요({{number}})',
                powered_by: '{{name}} 제공',
                overview: '신규 주문 알림',
                title: '{{name}}에 새로운 주문이 접수되었습니다.',
                subtitle: '주문 번호 {{number}}',
                description: '실시간 온라인 영수증을 통해 세부정보 및 업데이트를 확인하세요.',
                button_text: '주문 추적',
                track_delivery_button_text: '배송 추적',
            },
            email_order_completed_by_customer: {
                subject: '고객이 주문({{number}})을 완료했습니다.',
                powered_by: '{{name}} 제공',
                overview: '주문완료 알림',
                title: '{{name}}에 주문이 되었습니다.',
                subtitle: '주문 번호 {{number}}',
                description: '대시보드를 통해 또는 영수증을 사용하여 세부 정보를 확인하고 주문을 업데이트하세요.',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) 포함 가격에',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: '배송비',
            delivery_fee_offset: '배송비 할인',
            delivery_fee_total: '배송비 총액',
            promo: '할인: {{name}}({{value, currency}} + {{percent}}% 할인)',
            promo_percent: '할인: {{name}}({{percent}}%)',
            promo_fixed: '할인: {{name}}',
            promo_none: '할인: {{name}}',
            cart: '카트',
            tip: '팁 주문',
            total: '총',
        },
        status: {
            unconfirmed: '미확인',
            awaiting_payment: '결제 대기 중',
            confirmed: '확인됨',
            ready: '준비가 된',
            on_route: '경로 중',
            complete: '완벽한',
            cancelled: '취소',
            seated: '착석',
        },
        searching: {
            lalamove_search_placeholder: 'Lalamove 배송ID로 주문 검색',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: '없는',
                },
            },
            dish: {
                no_stock: '품절',
                not_available: '사용할 수 없음',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: '이메일 확인 코드',
            register_confirmation_code_email: '귀하의 이메일 확인 코드는 {{confirmation_code}}입니다(24시간 후에 종료됨).',
            register_confirmation_code_email_onbehalf: '귀하의 이메일 확인 코드는 {{confirmation_code}}입니다(24시간 후에 만료됨). 이메일 주소 {{email}}에 대한 것입니다.',
        },
    },
};
//# sourceMappingURL=ko.js.map